<template>
    <div class="wang-editor">
        <div id="WangEditorRef"></div>
    </div>
</template>

<script>
import { uploadImgs } from '../api/notice'
import wangEditor from 'wangeditor';
const baseURL = process.env.VUE_APP_BASE_API;
import { getToken } from "../utils/app"
// let  editor = null;
export default {
    props:['content','editHeight'],
    components: {
    },
    data() {
        return {
            editor:null,
            editorData:'',
            isFirst:false,
        };
    },
    created(){
        console.log(this.content)

    },
    mounted() {
      this.editorData = this.content;
    },
    methods: {
       init(content){
           this.isFirst = true;
            this.$nextTick(() => {
                const editor = new wangEditor(`#WangEditorRef`);
           // 配置 onchange 回调函数，将数据同步到 vue 中
             editor.config.onchange = (newHtml) => {
               this.editorData = newHtml;
                    //this.$emit("editorContent", newHtml);
             };
                editor.config.height = 500
                // 菜单
                editor.config.menus = [
                    'head',
                    'bold',
                    'fontSize',
                    'fontName',
                    'italic',
                    'underline',
                    'strikeThrough',
                    'indent',
                    'lineHeight',
                    'foreColor',
                    'backColor',
                    'link',
                    'list',
                    'todo',
                    'justify',
                    'quote',
                    'emoticon',
                    'image',
                    // 'video',
                    // 'table',
                    'code',
                    'splitLine',
                    'undo',
                    'redo',
                ]
                // 上传图配置

                // base64方法
                // editor.config.uploadImgShowBase64 = true;// 存为base64
                // 配置行高
                editor.config.lineHeights = ['1', '1.2', '1.4', '1.6', '1.8', '2', '2.4', '3']

                editor.config.uploadImgMaxSize = 2 * 1024 * 1024;
                editor.config.uploadImgServer = this.upload1();
                editor.config.uploadFileName = 'file'; //自定义文件名
                editor.config.uploadImgHeaders = {
                    'Authentication': this.token()
                }
                editor.config.uploadImgHooks = {
                    customInsert: function(insertImg, result, editor) {
                        insertImg(result.data.url);
                    }
                }

                editor.create();
                if(content){
                    editor.txt.html(content)
                }
                this.editor=editor;
            })
       },
    },
    watch:{
        "editorData":function(val){
            this.$emit('callback',{type:'editorContent',value:val})
        }
    },
    beforeDestroy(){
        console.log('销毁')
        this.editor.destroy();
        this.editor = null;
    }
};
</script>

<style lang="scss">
    .wang-editor{
        #WangEditorRef{
            /* min-height: 300px; */
            height: 550px;
        }

    }
</style>
